/* eslint-disable */
import axios from 'axios';

import Billing from '@web-solutions/module-billing';

import { useStore } from '../store/store';
import { getEnvUrl } from './getEnvUrl';
import { validateEmail } from './validateEmail';

const STRIPE = 'stripe';

/**
 * Stripe deferred-email + Apple Pay (voery): if the Apple Pay sheet returned an
 * email (stashed on `window.__apple_pay_payer_email__` by ApplePayButton), attach
 * it to the anonymous Stripe customer via `POST /auth/email/attach` and skip the
 * email-after-payment page. Always clears the stash. Returns true if it attached.
 *
 * No-op unless `collectEmailAfterPayment` + Stripe and a valid email was returned.
 */
export async function attachApplePayEmailIfPresent(opts: {
  collectEmailAfterPayment?: boolean;
  paymentSystem?: string;
}): Promise<boolean> {
  const email =
    typeof window !== 'undefined' ? (window as any).__apple_pay_payer_email__ : undefined;

  // Always clear the stash so a later card payment can't reuse a stale value.
  if (typeof window !== 'undefined') {
    (window as any).__apple_pay_payer_email__ = undefined;
  }

  if (!opts.collectEmailAfterPayment || opts.paymentSystem !== STRIPE) return false;
  if (!email || !validateEmail(email)) return false;

  const { apiBaseUrl } = getEnvUrl();
  const token = Billing.stripeCustomerToken || useStore.getState().authTokens?.accessToken;

  try {
    await axios.post(
      `${apiBaseUrl}/auth/email/attach`,
      { email },
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
  } catch (error) {
    console.error('[attachApplePayEmailIfPresent] /auth/email/attach failed', error);
  }

  useStore.getState().setEmail(email);
  useStore.getState().addSkippedPage('email-after-payment');
  return true;
}
